<template>
  <v-card class="mb-3">
    <v-list-item>
      <v-list-item-content>
        {{$t('payType_title1')}}
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list-item>
      <v-list-item-content>
        <p class="subsubtitle__sty alert__sty">※{{$t('payType_text1')}}</p>
        <v-radio-group v-model="PayradioGroup" @change="onPayTypeChange($event)">
          <v-radio
            v-for="(item, idx) in payradio"
            :key="'A' + idx"
            :label="item.pay_method"
            :value="item.pay_id"
            v-show="item.is_support"
          ></v-radio>
        </v-radio-group>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: 'payType',

  data: () => ({
    access_key: 'rIhTQzuOwZ54asxqRMNkYVF3n6UA7v9c',
    user_uuid: '',
    group_uuid: '',
    PayradioGroup: null,
    payradio: [],
  }),
  methods: {
    getPayFunction() {
      if (this.$store.state.productinfo.productinfoData !== undefined &&
        this.$store.state.productinfo.productinfoData.length > 0) {
        this.PayradioGroup = this.$store.state.productinfo.productinfoData[0].product_pay_type_choose;
        this.payradio = this.$store.state.productinfo.productinfoData[0].product_pay_type;
      } else {
        return false;
      }
    },
    onPayTypeChange(event) {
      // console.log(event);
      this.$store.state.productinfo.productinfoData[0].product_pay_type_choose = event;
    },
  },
  mounted() {
    this.getPayFunction();
  },
  watch: {
  },
};
</script>
